export const UserListComponetName = "UserList";

export const updateUserListFilters = (filters) => {
  return {
    type: 'SET_USER_LIST_FILTERS',
    filters
  }
}
